export default ['$q', 'JsonRPCService', 'policyjob.endpointConfig', 'policyjob.xCenterRouteConfig', ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) => {

    const xCenterRoute = xCenterRouteConfig;
    const endpoint = endpointConfig.vinlookup;

    return {

        vinSearchTempData: {
            multipleVinResults: false,
            isLicenseSearchComplete: false,
            isVinSearchCompleted: false,
            noResultOnLicenseSearch: false,
            emptyVinSearchData: false,
            revalidateError: false,
        },
        autofillBasedOnVIN: (vin) => {
            const deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupBasedOnVIN', [vin]).then((vehicleInfo) => deferred.resolve(vehicleInfo), (error, status, headers) => deferred.reject([error, status, headers]));
            return deferred.promise;
        },
        autofillBasedOnPartialDto(dto) {
            const deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupBasedOnPartialDTO', [dto]).then(vehicleInfo => deferred.resolve(vehicleInfo), (error, status, headers) => deferred.reject([error, status, headers]));
            return deferred.promise;
        },
        lookupMakes() {
            const deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'lookupMakes', []).then((vehicleInfo) => deferred.resolve(vehicleInfo), (error, status, headers) => deferred.reject([error, status, headers]));
            return deferred.promise;
        },
        disableData: {
            make: false,
            model: false,
            carPower: false,
            energy: false,
            vehicleSpec: false
        },
        vinSearchResponseFieldsCount: 0,
        licenseSearchResponseFieldsCount: 0,
        nscValuesUpdated: false,
        nscMoreResultFound: false,
        nscNoVehicleInfo: false,
        nscVINValidated: true,
        nscSellerSiteValidated: true,
        nscVin: undefined,
        nscBrandRRDI: undefined
    };
}];